import gql from 'graphql-tag';

const UPDATE_AUTO_START_TIMER_INFO = gql`
  mutation($timerInfo: AutoStartTimer!) {
    updateAutoStartTimerInfo(input: $timerInfo)
  }
`;

export { UPDATE_AUTO_START_TIMER_INFO };
